const GROUPS = {
  STATE: {
    ACTIVE: 1,
    ARCHIVED: 2,
  },
};

export default GROUPS;
